import { render, staticRenderFns } from "./EditarAlergia.vue?vue&type=template&id=6061611e"
import script from "./EditarAlergia.vue?vue&type=script&lang=js"
export * from "./EditarAlergia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports